import '@cloudscape-design/global-styles/index.css';
import '@uiw/react-markdown-preview/markdown.css';
import '@uiw/react-md-editor/markdown-editor.css';

import { BrowserRouter as Router } from 'react-router-dom';
import { useLocalStorage } from 'react-use';

import { AppLayoutToolbar } from '@cloudscape-design/components';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AbvCalculator from './components/AbvCalculator';
import ChangesPanel from './components/ChangesPanel';
import DepartmentSelector from './components/DepartmentSelector';
import Hint from './components/Hint';
import HoneyCalculator from './components/HoneyCalculator';
import LanguageSelector from './components/LanguageSelector';
import AlgoliaSearch, { typeToCollection } from './components/modules/AlgoliaSearch';
import AlertContextProvider from './contexts/AlertContext';
import { AuthContextProvider } from './contexts/AuthContext';
import { RefreshContextProvider } from './contexts/RefreshContext';
import Approve from './layout/Approve';
import Loginout from './layout/Loginout';
import { PrintRouting } from './layout/PrintRouting';
import { Routing } from './layout/Routing';
import Sidebar from './layout/Sidebar';

function App() {
  const [nav, setNav] = useLocalStorage('nav', true);
  const [tool, setTool] = useLocalStorage('tool', false);

  return (
    <AlertContextProvider>
      <RefreshContextProvider>
        <AuthContextProvider>
          <Router>
            {window.location.pathname?.endsWith('/print') ? (
              <PrintRouting />
            ) : (
              <AppLayoutToolbar
                breadcrumbs={
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ width: 250 }}>
                      <AlgoliaSearch
                        maxResults={25}
                        onSelectRecord={(record) =>
                          (window.location.href = `/${typeToCollection[record.type] || `${record.type}s`}/${record.itemId}`)
                        }
                      />
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <DepartmentSelector />
                      <LanguageSelector />
                    </div>
                  </div>
                }
                navigationOpen={nav}
                onNavigationChange={({ detail }) => setNav(detail.open)}
                toolsOpen={tool}
                onToolsChange={({ detail }) => setTool(detail.open)}
                splitPanel={<ChangesPanel />}
                navigation={
                  <>
                    <Sidebar />
                    <Approve />
                    <Loginout />
                  </>
                }
                content={
                  <>
                    <Routing />
                    <ToastContainer />
                  </>
                }
                tools={
                  <div style={{ marginTop: 40, padding: 8 }}>
                    <Hint />
                    <AbvCalculator />
                    <HoneyCalculator />
                  </div>
                }
              />
            )}
          </Router>
        </AuthContextProvider>
      </RefreshContextProvider>
    </AlertContextProvider>
  );
}

export default App;
